module.exports = __webpack_public_path__ + "img/10-vogelspeelgoed.0edc0b29.jpg";